import { Injectable } from '@angular/core';
import { ISourceSystemType } from '../../../foundation/models/enums/source-system-type.enum';
import { IRoute } from '../../models/iroute.interface';
import { RouteBuilderService } from './route-builder.service';

@Injectable()
/**
 * Builds transaction routes for case
 */
export class CaseRouteBuilderService extends RouteBuilderService {

    constructor() {
        super();
    }

    public get sourceSystemType(): ISourceSystemType {
        return this.sourceSystemTypes.Case;
    }

    /**
     * Gets the route list for the transaction type provided.
     * @returns: Array of routes for transaction.
     */
    getRouteList(businessTransactionTypeId: number): any[] {
        const routeList: IRoute[] = [];

        return routeList;
    }
}
